import { apiClient } from './apiClient';

export type DashboardChartSlice = {
  label: string;
  value: number;
  count: number;
};

export type DashboardTrendPoint = {
  date: string;
  count: number;
};

export type ProspectionDashboard = {
  prospectsTotal: number;
  prospectsThisMonth: number;
  prospectsPendingEnrichment: number;
  prospectsEnriched: number;
  campaignsTotal: number;
  funnelCaptured: number;
  funnelLeads: number;
  funnelLost: number;
  prospectsByCampaign: DashboardChartSlice[];
  prospectsByEnrichmentStatus: DashboardChartSlice[];
  collectionTrend: DashboardTrendPoint[];
  enrichmentTrend: DashboardTrendPoint[];
  generatedAtUtc: string;
};

export async function fetchProspectionDashboard(): Promise<ProspectionDashboard> {
  const response = await apiClient.get<ProspectionDashboard>('/v1/dashboard/prospection');
  return response.data;
}
